export default __webpack_public_path__ + "static/media/link-btn.3f5167dc.svg";